import React, { useEffect, useState } from "react";
import styles from "./Organisation.module.css";
import TrainLoader from "../Loader/Loader";

const RailwayUnionsTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Define headers manually to match table structure
  const headers = [
    "Code",
    "HQ",
    "Union Name",
    "Union Code",
    "President",
    "President Phone",
    "General Secretary",
    "General Secretary Phone",
    "Zonal Secretary",
    "Zonal Secretary Phone",
  ];

  useEffect(() => {
    fetch(
      "https://opensheet.elk.sh/19NfX14cD73sQGqk8yCiOjks_hfWvLJDDvmZVUw0G_pM/OtherRail"
    )
      .then((res) => res.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Failed to load data.");
        setLoading(false);
      });
  }, []);

  if (loading) return <TrainLoader />;
  if (error) return <p className={styles.error}>{error}</p>;

  return (
    <div className={styles.TableContainer}>
      <table className={styles.membersTable}>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header, colIndex) => {
                const value = row[header] || ""; // default to empty if missing
                return (
                  <td key={colIndex}>
                    {/\d{10}/.test(value) ? (
                      <>
                        <div>{value.slice(0, -10).trim()}</div>
                        <div>{value.slice(-10)}</div>
                      </>
                    ) : (
                      value
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RailwayUnionsTable;
